var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 34,
    viewBox: "0 0 33 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1039_1183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7048 8.8809C11.4464 9.03009 11.2578 9.27581 11.1806 9.56401C11.1034 9.85221 11.1438 10.1593 11.293 10.4177L18.1836 22.3526L11.5865 20.5842C11.2978 20.5069 10.9902 20.5474 10.7314 20.6968C10.4726 20.8462 10.2837 21.0924 10.2063 21.3811C10.129 21.6698 10.1695 21.9774 10.3189 22.2362C10.4683 22.4951 10.7145 22.684 11.0032 22.7613L20.2239 25.232C20.3668 25.2706 20.516 25.2805 20.6628 25.2613C20.8096 25.2421 20.9512 25.1941 21.0794 25.1201C21.2077 25.0461 21.32 24.9475 21.41 24.8299C21.5001 24.7124 21.566 24.5782 21.6041 24.4351L24.0748 15.2145C24.1131 15.0715 24.1228 14.9224 24.1035 14.7757C24.0842 14.629 24.0362 14.4875 23.9622 14.3593C23.8882 14.2311 23.7897 14.1188 23.6723 14.0287C23.5548 13.9386 23.4208 13.8725 23.2779 13.8342C23.1349 13.7959 22.9858 13.7861 22.8391 13.8055C22.6924 13.8248 22.5509 13.8728 22.4227 13.9468C22.2946 14.0208 22.1822 14.1193 22.0921 14.2367C22.002 14.3541 21.936 14.4881 21.8977 14.6311L20.1322 21.2276L13.2416 9.29268C13.0924 9.03429 12.8467 8.84574 12.5585 8.76851C12.2703 8.69129 11.9632 8.73172 11.7048 8.8809Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1039_1183"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(-0.5 -0.866025 -0.866025 0.5 32.7846 21.3926)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegArrow);
export default __webpack_public_path__ + "static/media/reg-arrow.6e818d23b609f823e4ddad5b38aebfa8.svg";
export { ForwardRef as ReactComponent };